import React from 'react';
import { Flex, Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { layout } from 'styled-system';
import { ReactComponent as LivePersonSVG } from '../assets/liveperson_logo.svg';
import { ReactComponent as SidebarShapeSVG } from '../assets/sidebar_shape.svg';
import { ReactComponent as SidebarLogoSVG } from '../assets/sidebar_maven_logo.svg';

const backgroundGradient = theme('mode', {
  light: (props) => props.theme.gradients.blue,
  dark: (props) => props.theme.gradients.blue,
});

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.midLightGrey,
  dark: (props) => props.theme.colors.midLightGrey,
});

const logoColor = theme('mode', {
  light: (props) => props.theme.colors.mediumPurple,
  dark: (props) => props.theme.colors.midLightGrey,
});

const shapeColor = theme('mode', {
  light: (props) => props.theme.colors.lightBlue2,
  dark: (props) => props.theme.colors.royalBlue,
});

const Logo = styled(LivePersonSVG)`color: ${iconColor};`;

const SidebarShape = styled(SidebarShapeSVG)`
  ${layout}
  color: ${shapeColor};
  position: absolute;
  top: 50px;
  right: 0;
  width: 54px;
  height: 724px;
`;

const SidebarLogo = styled(SidebarLogoSVG)`
  ${layout}
  color: ${logoColor};
  position: absolute;
  top: 50px;
  right: 0;
  width: 54px;
  height: 724px;
`;

const ParentNavWrapper = styled(Flex)`
  color: ${logoColor};
  position: relative;
  background-repeat: no-repeat;
  background-image: ${backgroundGradient};
  width: 60px;
`;

function ParentNav() {
  return (
    <ParentNavWrapper flex="0 0 60px" alignItems="flex-start">
      <Box width={60} p={2}>
        <Logo />
        <SidebarShape />
        <SidebarLogo />
      </Box>
    </ParentNavWrapper>
  );
}

export default ParentNav;
